import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    this.showTab("text");
  }

  switch(event) {
    const tabName = event.currentTarget.dataset.tab;
    this.showTab(tabName);
  }

  showTab(name) {
    this.tabTargets.forEach((tab) => {
      if (tab.dataset.tab === name) {
        tab.classList.add("border-purple-500", "text-purple-700", "bg-purple-50");
        tab.classList.remove(
          "border-transparent",
          "text-gray-500",
          "hover:text-gray-700",
        );
      } else {
        tab.classList.remove(
          "border-purple-500",
          "text-purple-700",
          "bg-purple-50",
        );
        tab.classList.add(
          "border-transparent",
          "text-gray-500",
          "hover:text-gray-700",
        );
      }
    });

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tab !== name);
    });
  }
}
